import { AuthUrls, } from "@/modules/auth/common/enum";
import type {
  IChallengeId,
  ICheckVerificationCodeRequest,
  IIdentifyUserRequest,
  IIdentifyUserWithUsernameRequest,
  ILoginRequest,
  ILoginWithOtpRequest,
  IQRExchangeResponse,
  IQRResponse,
  ISendVerificationCodeRequest,
  ISendVerificationCodeResponse,
  ISetPasswordRequest,
  LoginResponse,
  LoginWithOtpResponse,
} from "@/modules/auth/common/types";
import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "app/axios";

export const authApi = createApi({
  reducerPath: "authApi",
  baseQuery: axiosBaseQuery(),
  endpoints: (builder) => ({
    login: builder.mutation<LoginResponse, ILoginRequest>({
      query: (credentials) => ({
        url: AuthUrls.Login,
        method: "POST",
        data: credentials,
      }),
    }),
    loginWithOtp: builder.mutation<LoginWithOtpResponse, ILoginWithOtpRequest>({
      query: (credentials) => ({
        url: AuthUrls.LoginWithOTP,
        method: "POST",
        data: credentials,
      }),
    }),
    identifyUser: builder.mutation<IChallengeId, IIdentifyUserRequest>({
      query: (credentials) => ({
        url: AuthUrls.IdentifyUser,
        method: "POST",
        data: credentials,
      }),
    }),
    identifyUserByUsername: builder.mutation<
      IChallengeId,
      IIdentifyUserWithUsernameRequest
    >({
      query: (credentials) => ({
        url: AuthUrls.IdentifyUserByUsername,
        method: "POST",
        data: credentials,
      }),
    }),
    sendVerificationCode: builder.mutation<
      ISendVerificationCodeResponse,
      ISendVerificationCodeRequest
    >({
      query: (credentials) => ({
        url: AuthUrls.SendVerificationCode,
        method: "POST",
        data: credentials,
      }),
    }),
    checkVerificationCode: builder.mutation<
      IChallengeId,
      ICheckVerificationCodeRequest
    >({
      query: (credentials) => ({
        url: AuthUrls.CheckVerificationCode,
        method: "POST",
        data: credentials,
      }),
    }),
    resetPassword: builder.mutation<IChallengeId, ISetPasswordRequest>({
      query: (credentials) => ({
        url: AuthUrls.ResetPassword,
        method: "POST",
        data: credentials,
      }),
    }),
    signOut: builder.mutation<void, void>({
      query: () => ({
        url: AuthUrls.SignOut,
        method: "POST",
        data: {},
      }),
    }),
    getQr: builder.query<IQRResponse, void>({
      query: () => ({
        url: AuthUrls.QR
      }),
      keepUnusedDataFor: 0
    }),
    qrExchange: builder.mutation<IQRExchangeResponse, string>({
      query: (csrfToken) => ({
        url: AuthUrls.QRExchange,
        method: "POST",
        headers: {
          "X-QR-CSRF": csrfToken
        }
      }),
    }),
  }),
});

export const {
  useGetQrQuery,
  useLoginMutation,
  useQrExchangeMutation,
  useLoginWithOtpMutation,
  useIdentifyUserMutation,
  useIdentifyUserByUsernameMutation,
  useSendVerificationCodeMutation,
  useCheckVerificationCodeMutation,
  useResetPasswordMutation,
  useSignOutMutation,
} = authApi;
